module.exports = __webpack_public_path__ + "img/header.067edd4.jpg";